import { ReactElement } from 'react';
import { IComponentContactCardsFields } from 'types/contentful';
import ContactCards from 'components/UI/ContactCards';

export default function ContentfulContactCards({
  items,
}: IComponentContactCardsFields): ReactElement | null {
  return <ContactCards items={items} className="ecp-my" />;
}
